import * as React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuthorization } from '../Contexts/Hooks/useAuth';
import { Box, CircularProgress, Stack } from '@mui/material';
import UserTopMenu from './UserTopMenu';
import { fullHeight } from '../Shared/getFullHeight';

export interface IUserLayoutProps {
}

export default function UserLayout(props: Readonly<IUserLayoutProps>) {

    return <Box height='100vh' display='flex' overflow='hidden' flexDirection='column' justifyContent='space-between'>
        <UserTopMenu />
        <Box sx={{ position: 'absolute', top: 56, overflow: 'hidden' }}>
            <Outlet />
        </Box>
    </Box>
}

